import styled from 'styled-components';
import { Skeleton } from 'ui/skeleton';
import { body2Bold, colors, spacing } from 'ui/theme';
import { MessageMedium } from 'constants/messageMediums';
import { getMessageHeaderByType } from 'modules/ai/nba/utils';
import { ColorText } from 'modules/ai/nba/components/campaigns/NBACampaignsSlideOver.styles';
import { StyledGradientSpinner } from 'modules/ai/copyAssist/components/dropdown/styles';

const SuggestionAppliedContainer = styled.div`
  color: ${colors.textSecondary};
  display: flex;
  align-items: center;
  gap: ${spacing.quarter};
`;

const StyledColorText = styled.span`
  ${body2Bold};
  margin-top: 0;
`;

export const SUGGESTION_APPLIED_TEST_ID = 'suggestion-applied';

export const SuggestionApplied = ({
  isDirty,
  isLoading,
  messageMedium,
}: { isDirty: boolean; isLoading: boolean; messageMedium: MessageMedium }) => {
  const messageHeaderByType = getMessageHeaderByType(messageMedium);

  return (
    <SuggestionAppliedContainer data-test={SUGGESTION_APPLIED_TEST_ID}>
      {isLoading ? (
        <>
          <StyledGradientSpinner />
          <Skeleton width={500} height={16} />
        </>
      ) : (
        <>
          <ColorText as={StyledColorText}>{messageHeaderByType} updated!</ColorText>
          {isDirty && <>Save your changes to update your running campaign or cancel to undo</>}
        </>
      )}
    </SuggestionAppliedContainer>
  );
};
